/* eslint-disable max-len */
import { useFormikContext } from 'formik';
import { ReactElement } from 'react';
import { FormRadioListOrientation } from '../../../../types/propTypes/FormRadioListPropTypes';
import { NPSE_OutcomePanelPropTypes } from '../../../../types/propTypes/NPSE_OutcomePanelPropTypes';
import { isStateNonAdmin } from '../../../../utilities/userUtilities';
import FormDateSelector from '../../../FormInputs/FormDateSelector/FormDateSelector';
import FormDropdown from '../../../FormInputs/FormDropdown/FormDropdown';
import FormRadioList from '../../../FormInputs/FormRadioList/FormRadioList';
import './NPSE_OutcomePanel.css';
import { 
  selectHasSearchMatch,
} from '../../../../redux/slices/nonPublicStudentSlice';
import { useAppSelector } from '../../../../redux/hooks';
import { MAX_DATE } from 'src/types/Constants';

const NPSE_OutcomePanel = ({
  label,
  fields,
  entryScoreOptions,
  exitScoreOptions,
  progressOptions,
  allowEdit 
}: NPSE_OutcomePanelPropTypes): ReactElement => {
  const { values } = useFormikContext();
  const formValues = values as Record<string, unknown>;

  const hasSearchMatch: boolean = useAppSelector(
    selectHasSearchMatch
  );

  const isEntryDateRequired = (): boolean => {
    return (
      formValues[fields.entryScore] !== undefined &&
      (formValues[fields.entryScore] as string).length > 0
    );
  };

  const isExitDateRequired = (): boolean => {
    return (
      formValues[fields.exitScore] !== undefined &&
      (formValues[fields.exitScore] as string).length > 0
    );
  };

  const isProgressRequired = (): boolean => {
    return (
      formValues[fields.entryScore] !== undefined &&
      (formValues[fields.entryScore] as string).length > 0 &&
      formValues[fields.exitScore] !== undefined &&
      (formValues[fields.exitScore] as string).length > 0
    );
  };

  const areFormComponentsDisabled: boolean =
    !allowEdit || !hasSearchMatch || isStateNonAdmin();

  return (
    <div className="outcome-panel">
      <div>
        <label className="field-label" data-testid="outcome-label">
          {label}
        </label>
      </div>
      <div className="field-row-outcomes top-row">
        <FormDropdown
          displayName="Entry Score"
          field={fields.entryScore}
          disabled={areFormComponentsDisabled}
          options={entryScoreOptions}
          isClearable={true}
        />
        <FormDateSelector
          displayName="Entry Score Date"
          field={fields.entryScoreDate}
          disabled={!isEntryDateRequired() || areFormComponentsDisabled}
          classConfig={{
            labelClasses: isEntryDateRequired() ? 'forced-required-label' : '',
          }}
          maxDate={MAX_DATE}
          isClearable
        />
      </div>
      <div className="field-row-outcomes">
        <FormDropdown
          displayName="Exit Score"
          field={fields.exitScore}
          disabled={areFormComponentsDisabled}
          options={exitScoreOptions}
          isClearable={true}
        />
        <FormDateSelector
          displayName="Exit Score Date"
          field={fields.exitScoreDate}
          disabled={!isExitDateRequired() || areFormComponentsDisabled}
          classConfig={{
            labelClasses: isExitDateRequired() ? 'forced-required-label' : '',
          }}
          maxDate={MAX_DATE}
          isClearable
        />
        <FormRadioList
          displayName="Progress"
          field={fields.progress}
          optionOrientation={FormRadioListOrientation.Horizontal}
          options={progressOptions}
          disabled={!isProgressRequired() || areFormComponentsDisabled}
          classConfig={{
            labelClasses: isProgressRequired() ? 'forced-required-label' : '',
          }}
        />
      </div>
    </div>
  );
};

export default NPSE_OutcomePanel;
